import { PREACHER } from 'store/types'
import { preacherConnector } from 'shared/connectors'
import { showPreloader, hidePreloader } from 'store/actions/viewManagement'
import { getSelectedRow } from 'store/selectors/viewManagementSelector'
import { updateSelectedRow } from '../viewManagement'

const success = () => ({
  type: PREACHER.EDIT_PREACHER_SUCCESS,
})

const editPreacher = preacherData => async (dispatch, getState) => {
  try {
    dispatch(showPreloader())

    const { error = false } = getSelectedRow(getState())
    await preacherConnector.editPreacher(preacherData, error)

    dispatch(success())
    dispatch(hidePreloader())
    return true
  } catch ({ response: { data } }) {
    dispatch(updateSelectedRow(data))
    dispatch(hidePreloader())
    return false
  }
}

export default editPreacher
